import { defineMessages } from 'react-intl';

const messages = defineMessages({
  collegeFairDetails: {
    id: 'college-fair-details.collegeFairDetails',
    defaultMessage: 'College Fair Details',
  },
  date: {
    id: 'college-fair-details.date',
    defaultMessage: 'Date',
  },
  time: {
    id: 'college-fair-details.time',
    defaultMessage: 'Time',
  },
  rsvpDeadline: {
    id: 'college-fair-details.rsvpDeadline',
    defaultMessage: 'RSVP Deadline',
  },
  cost: {
    id: 'college-fair-details.cost',
    defaultMessage: 'Cost',
  },
  numberOfStudentsExpected: {
    id: 'college-fair-details.numberOfStudentsExpected',
    defaultMessage: 'Number of Students Expected',
  },
  instructions: {
    id: 'college-fair-details.instructionsForColleges',
    defaultMessage: 'Instructions',
  },
  confirmRequests: {
    id: 'college-fair-details.confirmRequests',
    defaultMessage: 'Automatically Confirm Incoming Requests From Colleges',
  },
  yes: {
    id: 'college-fair-details.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'college-fair-details.no',
    defaultMessage: 'No',
  },
  emailMessage: {
    id: 'college-fair-details.emailMessage',
    defaultMessage: 'Email Message to Colleges After Confirmation',
  },
  numberOfSpotsFilled: {
    id: 'college-fair-details.numberOfSpotsFilled',
    defaultMessage: '{count, number} of {max, number}',
  },
  spotsFilled: {
    id: 'college-fair-details.spotsFilled',
    defaultMessage: 'Spots Filled',
  },
  contactDetails: {
    id: 'college-fair-details.contactDetails',
    defaultMessage: 'Contact Details',
  },
  representative: {
    id: 'college-fair-details.representative',
    defaultMessage: 'Representative',
  },
  school: {
    id: 'college-fair-details.college',
    defaultMessage: 'School',
  },
});

export default messages;
